<template>
  <ChartLayout :title="title" units="million USD" :half="half">
    <DataGetter :url="apiRoute" :params="params" v-slot="{ data }">
      <DataSlicer
        :data="data"
        x-axis-dimension="year"
        y-axis-dimension="category"
        value-dimension="value"
        v-slot="{ slicedData }"
      >
        <Chart
          :options="{
            ...chartOptions,
            series: slicedData.map((series, i) => ({
              ...series,
              index: seriesOrder.indexOf(series.name),
              colorIndex:
                series.name === 'Unknown'
                  ? 99
                  : seriesOrder.indexOf(series.name),
              data: series.data.map((row) => [row[0], row[1] / 1000000]),
            })),
          }"
        />
      </DataSlicer>
    </DataGetter>
    <template #notes>
      <p>
        Crunchbase data on funding received in USD has been deflated using the
        Bureau of Labor Statistics' Consumer Price Index, with a base year of
        2022 (Source: “Inflation Calculator.” U.S. Official Inflation Data,
        Alioth Finance, 29 Aug. 2022,
        <a href="https://www.officialdata.org/">https://www.officialdata.org/</a
        >).
      </p>
    </template>
  </ChartLayout>
</template>

<script>
import { Chart } from "highcharts-vue";
import ChartOptions, {
  ChartLayout,
} from "@international-energy-agency/vue-ui/highcharts";
import { DataGetter, DataSlicer } from "@international-energy-agency/vue-ui";
export default {
  props: {
    title: {
      type: String,
      required: false,
    },
    apiRoute: {
      type: String,
      default: "https://api.iea.org",
    },
    countryISO: {
      type: String,
      required: true,
    },
    grouping: {
      type: String,
      required: true,
    },
    half: {
      type: Boolean,
      default: false,
    },
  },
  components: {
    Chart,
    ChartLayout,
    DataGetter,
    DataSlicer,
  },
  data() {
    return {
      seriesOrder: ["Early stage", "Later stage"],
      chartOptions: ChartOptions.buildOptions(
        {
          plotOptions: {
            column: {
              groupPadding: 0,
            },
          },
          yAxis: {
            className: "highcharts-show-grid",
          },
        },
        "column"
      ),
    };
  },
  computed: {
    params() {
      return {
        allYears: true,
        startYear: 2000,
        indicator: ["Fundings of start-ups"],
        techSector: this.grouping,
        countryISO: this.countryISO,
        unit: "USD",
      };
    },
  },
};
</script>
